module.exports = __webpack_public_path__ + "53d1d58f8c34dc41b0945ec73930faac.pdf";